import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  errorTitle: {
    id: '6usZ5x',
    defaultMessage: 'Import error',
    description: 'Error header after import failed to start',
  },
  errorContent: {
    id: 'Qsx/wv',
    defaultMessage: 'An error occurred while starting the import. Please try again.',
    description: 'Error content after import failed to start',
  },
});
